import { render, staticRenderFns } from "./issuseInterestDetails.vue?vue&type=template&id=0ed90c24&scoped=true&"
import script from "./issuseInterestDetails.vue?vue&type=script&lang=js&"
export * from "./issuseInterestDetails.vue?vue&type=script&lang=js&"
import style0 from "./issuseInterestDetails.vue?vue&type=style&index=0&id=0ed90c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed90c24",
  null
  
)

export default component.exports